<template>

	<div class="box size75   transition-fadeinup transition-delay-02">
		<h2>Content history log</h2>
		<br>

		<div class="negative-padding">
			<table cellpadding="0" cellspacing="0" class="data">
				<thead>
				<tr>
					<th></th>
					<th>Title</th>
					<th>Type</th>
					<th>Data</th>
					<th>User</th>
					<th></th>
					<th></th>
				</tr>
				</thead>

				<tbody>
				<tr>
					<td></td>
					<td>Title of this record</td>
					<td><a  href="pages/content-list.php" data-routing-target="#main">DocOffice</a></td>
					<td>20 august 2019, 15:35</td>
					<td>Michael Vleminckx</td>
					<td class="btns">
						<a href="pages/content-add.php" data-routing-target="#main"><i class="fa fa-pen"></i></a>
					</td>
					<td></td>
				</tr>
				<tr>
					<td></td>
					<td>Title of this record</td>
					<td><a  href="pages/content-list.php" data-routing-target="#main">DocOffice</a></td>
					<td>20 august 2019, 15:35</td>
					<td>Michael Vleminckx</td>
					<td class="btns">
						<a href="pages/content-add.php" data-routing-target="#main"><i class="fa fa-pen"></i></a>
					</td>
					<td></td>
				</tr>
				<tr>
					<td></td>
					<td>Title of this record</td>
					<td><a  href="pages/content-list.php" data-routing-target="#main">DocOffice</a></td>
					<td>20 august 2019, 15:35</td>
					<td>Michael Vleminckx</td>
					<td class="btns">
						<a href="pages/content-add.php" data-routing-target="#main"><i class="fa fa-pen"></i></a>
					</td>
					<td></td>
				</tr>
				<tr>
					<td></td>
					<td>Title of this record</td>
					<td><a  href="pages/content-list.php" data-routing-target="#main">DocOffice</a></td>
					<td>20 august 2019, 15:35</td>
					<td>Michael Vleminckx</td>
					<td class="btns">
						<a href="pages/content-add.php" data-routing-target="#main"><i class="fa fa-pen"></i></a>
					</td>
					<td></td>
				</tr>
				<tr>
					<td></td>
					<td>Title of this record</td>
					<td><a  href="pages/content-list.php" data-routing-target="#main">DocOffice</a></td>
					<td>20 august 2019, 15:35</td>
					<td>Michael Vleminckx</td>
					<td class="btns">
						<a href="pages/content-add.php" data-routing-target="#main"><i class="fa fa-pen"></i></a>
					</td>
					<td></td>
				</tr>
				</tbody>
			</table>
		</div>

	</div>

</template>

<script>

export default {
	name: 'historylog',
	data () {
		return {
			content: null
		}
	},

	created () {
		//  this.fetchData()
	},

	methods: {
		fetchData () {

		}
	}
}

</script>
